import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JalaliService {

    readonly g_days_in_month: number[] = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    readonly j_days_in_month: number[] = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29]

    convertToGregorian(j_y: number, j_m: number, j_d: number): [number, number, number] {
        const jy = j_y - 979
        const jm = j_m - 1
        const jd = j_d - 1
        let j_day_no = 365 * jy + Math.floor(jy / 33) * 8 + Math.floor((jy % 33 + 3) / 4)
        for (let i = 0; i < jm; ++i) {
            j_day_no += this.j_days_in_month[i]
        }
        j_day_no += jd
        let g_day_no = j_day_no + 79
        let gy = 1600 + 400 * Math.floor(g_day_no / 146097)
        g_day_no = g_day_no % 146097
        let leap = true
        if (g_day_no >= 36525) {
            g_day_no--
            gy += 100 * Math.floor(g_day_no / 36524)
            g_day_no = g_day_no % 36524
            if (g_day_no >= 365) {
                g_day_no++
            } else {
                leap = false
            }
        }
        gy += 4 * Math.floor(g_day_no / 1461)
        g_day_no %= 1461
        if (g_day_no >= 366) {
            leap = false
            g_day_no--
            gy += Math.floor(g_day_no / 365)
            g_day_no = g_day_no % 365
        }
        let i = 0
        while (g_day_no >= this.g_days_in_month[i] + Number(i === 1 && leap)) {
            g_day_no -= this.g_days_in_month[i] + Number(i === 1 && leap)
            i++
        }
        const gm = i + 1
        const gd = g_day_no + 1
        const gm_str = gm < 10 ? `0${gm}` : `${gm}`
        const gd_str = gd < 10 ? `0${gd}` : `${gd}`
        return [gy, Number(gm_str), Number(gd_str)]
    }

    daysOfMonth(month: number, year: number) {
        if (month === 11 || month === 10 || month === 9 || month === 8 || month === 7) {
            return 30
        }
        if (month === 1 || month === 2 || month === 3 || month === 4 || month === 5 || month === 6) {
            return 31
        }
        if (month === 12 && (year === 1300 || year === 1304 || year === 1309 || year === 1313 || year === 1317 || year === 1321 || year === 1325 || year === 1329 || year === 1333 || year === 1337 || year === 1342 || year === 1346 || year === 1350 || year === 1354 || year === 1358 || year === 1362 || year === 1366 || year === 1370 || year === 1375 || year === 1379 || year === 1383 || year === 1387 || year === 1391 || year === 1395 || year === 1399 || year === 1403 || year === 1408 || year === 1412 || year === 1416 || year === 1420 || year === 1424 || year === 1428 || year === 1432 || year === 1436 || year === 1441)) {
            return 30
        } else {
            return 29
        }
    }

    firstDayOfMonth(fullDate: string) {
        let result = 0
        if (fullDate.split(',')[0] === 'Saturday') {
            result = 0
        }
        if (fullDate.split(',')[0] === 'Sunday') {
            result = 1
        }
        if (fullDate.split(',')[0] === 'Monday') {
            result = 2
        }
        if (fullDate.split(',')[0] === 'Tuesday') {
            result = 3
        }
        if (fullDate.split(',')[0] === 'Wednesday') {
            result = 4
        }
        if (fullDate.split(',')[0] === 'Thursday') {
            result = 5
        }
        if (fullDate.split(',')[0] === 'Friday') {
            result = 6
        }
        return result
    }

}
